export default "__VITE_ASSET__ZTnknTde__"